// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeEmailTemplatePopup_content_container__mp51E {
  padding-bottom: 20px;
}

.ChangeEmailTemplatePopup_btn_no__9wWjO {
  font-weight: bold !important;
  width: 150px;
  color: grey !important;
  border: 1px solid grey !important;
  margin-left: 15px !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/ChangeEmailTemplatePopup/ChangeEmailTemplatePopup.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;EACjC,4BAA4B;AAC9B","sourcesContent":[".content_container {\n  padding-bottom: 20px;\n}\n\n.btn_no {\n  font-weight: bold !important;\n  width: 150px;\n  color: grey !important;\n  border: 1px solid grey !important;\n  margin-left: 15px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_container": `ChangeEmailTemplatePopup_content_container__mp51E`,
	"btn_no": `ChangeEmailTemplatePopup_btn_no__9wWjO`
};
export default ___CSS_LOADER_EXPORT___;
